<template>
  <div>
    <AlertMetricSelector />
  </div>
</template>

<script>
import AlertMetricSelector from '@frontend/dash3/js/components/alerts/AlertMetricSelector.vue';

import Advisor from '@frontend/dash3/js/shared/Advisor.js';

export default {
  data() {
    return {
      advisor: {},
    };
  },
  components: {
    AlertMetricSelector
  },
  methods: {},
  computed: {},
  created: function() {
    this.advisor = new Advisor();
  },
};
</script>

<style lang="scss">

</style>
